// extracted by mini-css-extract-plugin
export var anticlockwise = "cn_k3";
export var svg = "cn_k1";
export var wrapper = "cn_C";
export var wrapperFlexCenter = "cn_k2";